import { render } from "./ContactAdminView.vue?vue&type=template&id=5bf149dd&scoped=true"
import script from "./ContactAdminView.vue?vue&type=script&lang=js"
export * from "./ContactAdminView.vue?vue&type=script&lang=js"

import "./ContactAdminView.vue?vue&type=style&index=0&id=5bf149dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf149dd"]])

export default __exports__